module.exports = __webpack_public_path__ + "./Erica_b0db6c9dc5e42adc49e9f6b9e40a5db9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Erica.jpg
// module id = 492
// module chunks = 0